import React from "react";

type Props = {
  email: string;
  sendEmail: (event: React.MouseEvent<HTMLDivElement>) => void;
  emailOnChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  sendEmailSuccess: string;
  sendEmailError: string;
};

const PatientEnrolmentBookEyeCheckEmailSection = ({
  email,
  emailOnChange,
  sendEmail,
  sendEmailSuccess,
  sendEmailError,
}: Props) => (
  <div id="email-me-section" className="section-content">
    <p>You can also be sent a copy of the information to your email here:</p>
    <br />
    <label className="label-email">Your email address</label>
    <div className="mdc-layout-grid__inner">
      <div className="mdc-layout-grid__cell mdc-layout-grid__cell--span-8-desktop mdc-layout-grid__cell--span-6-tablet mdc-layout-grid__cell--span-4-phone">
        <input
          id="input-email-address"
          data-testid="input-email-address"
          type="text"
          name="email_address"
          className="input-text"
          value={email}
          onChange={emailOnChange}
        />
        <br />
        {sendEmailSuccess && (
          <span id="email-visit-card-success" className="message-text">
            {sendEmailSuccess}
          </span>
        )}
        {sendEmailError && (
          <span id="email-visit-card-error" className="error-text">
            {sendEmailError}
          </span>
        )}
      </div>
      <div className="mdc-layout-grid__cell mdc-layout-grid__cell--span-4-desktop mdc-layout-grid__cell--span-2-tablet mdc-layout-grid__cell--span-4-phone text-center">
        <div
          className="secondary-button"
          id="submit-email-address"
          data-testid="submit-email-address"
          onClick={sendEmail}
        >
          SEND EMAIL
        </div>
      </div>
    </div>
  </div>
);

export default PatientEnrolmentBookEyeCheckEmailSection;
